<div class="hero_area2">
    <app-menu [config]="config"></app-menu>
    <!-- <app-carrossel [config]="config"></app-carrossel> -->
</div>

<app-carrinho-body [config]="config"></app-carrinho-body>


